<template>
  <div class="text-base leading-none lg:text-sm">
    <div class="flex space-x-1 text-md text-gray-600">
      <span class="text-gray-500" data-testid="main-label">
        {{ $t('product_attribute.size') }}:
      </span>
      <span class="font-normal" data-testid="sub-label">
        {{ formatShoeSize(variantSize) }}
      </span>
    </div>
    <div class="mt-1 flex space-x-1 text-md text-gray-600">
      <span class="text-gray-500" data-testid="main-label">
        {{ $t('product_attribute.color') }}:
      </span>
      <span class="font-normal" data-testid="sub-label">
        {{ color }}
      </span>
    </div>
    <div
      v-if="isQuantityShown"
      class="mt-1 flex space-x-1 text-md text-gray-600"
    >
      <span class="text-gray-500" data-testid="main-label">
        {{ $t('global.quantity') }}:
      </span>
      <span class="font-normal" data-testid="sub-label">
        {{ item.quantity }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  type BasketItem,
  getAttributeValueTuples,
} from '@scayle/storefront-nuxt'
import { useFormat } from '~/composables/useFormat'
import { type ExtendedSizeSystem, useItemSize } from '~/composables/useItemSize'

const { formatShoeSize } = useFormat()

const { item, isQuantityShown = false } = defineProps<{
  item: BasketItem
  isQuantityShown?: boolean
}>()

const variantSize = useItemSize(
  item.variant?.attributes ?? {},
  item.customData?.activeSizeTab as ExtendedSizeSystem,
)?.label
const color = getAttributeValueTuples(item.product.attributes, 'color')
  .map((color) => color.label)
  .join('/')
</script>
